import {
  EXAM_EVENT_OVERVIEW_REPORT,
  EXAM_COURSE_ANALYSIS_REPORT,
  QBANK_ITEMS_ANALYSIS_REPORT,
  QBANK_ITEMS_ANALYSIS_YEARLY_REPORT,
  QSET_USAGE_STATUS_REPORT,
  QUESTION_USAGE_BY_QSET_REPORT,
  QUESTIONNAIRE_REPORT,
} from '@shared/permissions';

const APP_PERMISSIONS = {
  EXAM_EVENT_OVERVIEW_REPORT,
  EXAM_COURSE_ANALYSIS_REPORT,
  QBANK_ITEMS_ANALYSIS_REPORT,
  QBANK_ITEMS_ANALYSIS_YEARLY_REPORT,
  QSET_USAGE_STATUS_REPORT,
  QUESTION_USAGE_BY_QSET_REPORT,
  QUESTIONNAIRE_REPORT,
};

export { APP_PERMISSIONS };
